import { useState, useEffect, useRef, useMemo , useCallback } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';
import NavHeader from '../shared/Nav-Header';
import styles from './messages.module.css';
import defaultProfile1 from '../images/default-profile1.jpg';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { blockUser, unblockUser } from '../redux/blockSlice';
import { CopyIcon } from '../shared/icons/Icons';
import Notification from '../shared/Notification';
import { useAuth } from '../context/AuthContext';
import MessageBox from '../shared/MessageBox';


const getSocketURL = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://server-production-a1b2.up.railway.app/';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

const socket = io(getSocketURL(), { 
  transports: ['websocket', 'polling'],
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000
});


const MessagesPage = ({ roomId }) => {

    const [messages, setMessages] = useState([]);
    const [recentMessage, setRecentMessage] = useState('');
    // const [reloadMessage, setReloadMessage] = useState('');
    const [projectNetworkList, setProjectNetworkList] = useState([]);
    const [previousNetworkList, setPreviousNetworkList] = useState([]);
    const [activeChat, setActiveChat] = useState(null);
    const [currentRoomId, setCurrentRoomId] = useState(null);
    const [showOptions, setShowOptions] = useState(null);
    const {userId} = useAuth();
    // const [showReadBy, setShowReadBy] = useState(null);
    const [chatBoxPosition, setChatBoxPosition] = useState(() => {
        const savedPosition = localStorage.getItem('chatBoxPosition');
        return savedPosition ? JSON.parse(savedPosition) : {  right: 10, bottom: 20 };
    });
    const bottomRef = useRef(null);
    const chatBoxRef = useRef(null);
    const navigate = useNavigate();
    const [blockedStatusState, setblockedStatusState] = useState(false)
    const dispatch = useDispatch();
    const [notification, setNotification] = useState('');
    const [showActiveChatOptions, setShowActiveChatOptions] = useState(false);
    const blockedUsers = useSelector(state => state.block.blockedUsers);
    const token = useMemo(() => localStorage.getItem('token'), []);
    const [totalUnread, setTotalUnread] = useState(0);
    // const unreadCounts = useMemo(() => {
    //     const counts = {};
    //     projectNetworkList.forEach(network => {
    //         counts[network.roomId] = network.unreadCount || 0;
    //     });
    //     return counts;
    // }, [projectNetworkList]);
    // console.log("activeChat", activeChat);
    const [activeMessageBox, setActiveMessageBox] = useState(null);
    const [status, setStatus] = useState('');

    
    // useEffect(() => {
    //     // console.log("activeChat:", activeChat);
    //     if (!activeChat?._id) return;

    //     const startChat = async () => {
    //         try {
    //             const response = await axios.post(
    //                 '/api/applicant/messages/start-chat', 
    //                 { user1: userId, user2: activeChat?._id },
    //                 { headers: { Authorization: `Bearer ${token}` } }
    //             );

    //             if (response.data.success) {
    //                 const roomId = response.data.roomId;
    //                 setCurrentRoomId(roomId);
                    
    //                 // Join socket room
    //                 socket.emit('joinRoom', { roomId });
                    
    //                 // Fetch old messages
    //                 fetchOlderMessages(roomId);
    //             }
    //         } catch (error) {
    //             // console.error('Error starting chat:', error.message);
    //         }
    //     };

    //     startChat();
    //     return () => {
    //         if (currentRoomId) {
    //             socket.emit('leaveRoom', { roomId: currentRoomId });
    //         }
    //     };
    // }, [activeChat?._id]);

    useEffect(() => {
        const handleReceiveMessage = (newMessage) => {
            // console.log("adding message ", newMessage);

            if (newMessage.currentRoomId === currentRoomId) {
                setMessages((prevMessages) => {
                    const exists = prevMessages.some(msg => msg._id === newMessage._id);
                    if (exists) {
                        return prevMessages;
                    }
                    return [...prevMessages, newMessage];
                });
            if (newMessage.senderId !== userId) {
                // console.log("Marking message as read for message:", newMessage);
                    setTimeout(() => {
                        axios.post(
                            '/api/applicant/messages/mark-read',
                            { roomId: currentRoomId },
                            { headers: { Authorization: `Bearer ${token}` } }
                        ).catch(err => console.error('Error marking as read:', err));
                    }, 1000);
                }
            } else {
                setTotalUnread(prev => prev + 1);
                const updateUnreadCount = (prev) => {
                    return prev.map(friend => {
                        if (friend.roomId === newMessage.currentRoomId) {
                            return { 
                                ...friend, 
                                unreadCount: (friend.unreadCount || 0) + 1 
                            };
                        }
                        return friend;
                    });
                };
            
            setProjectNetworkList(updateUnreadCount);
            setPreviousNetworkList(updateUnreadCount);
        }
        };

        socket.on('receiveMessage', handleReceiveMessage);

        return () => {
            socket.off('receiveMessage', handleReceiveMessage);
        };
    }, [currentRoomId, userId]);

    useEffect(() => {
        const handleMessagesRead = ({ roomId, userId: readByUserId }) => {
            if (readByUserId === userId) {
                const clearUnreadCount = (prev) => {
                    return prev.map(friend => {
                        if (friend.roomId === roomId || activeChat?._id === friend._id) {
                            return { ...friend, unreadCount: 0 };
                        }
                        return friend;
                    });
                };

                setProjectNetworkList(clearUnreadCount);
                setPreviousNetworkList(clearUnreadCount);
            }
        };

        socket.on('messagesRead', handleMessagesRead);

        return () => {
            socket.off('messagesRead', handleMessagesRead);
        };
    }, [userId, activeChat]);

    useEffect(() => {
        if (activeChat && currentRoomId && token) {
            axios.post(
                '/api/applicant/messages/mark-read',
                { roomId: currentRoomId },
                { headers: { Authorization: `Bearer ${token}` } }
            ).catch(err => console.error('Error marking as read on chat open:', err));

            // Clear unread count in UI
            const clearUnreadForActiveChat = (prev) => {
                return prev.map(friend => 
                    friend._id === activeChat._id
                        ? { ...friend, unreadCount: 0 }
                        : friend
                );
            };

            setProjectNetworkList(clearUnreadForActiveChat);
            setPreviousNetworkList(clearUnreadForActiveChat);
        }
    }, [activeChat, currentRoomId, token]);

    useEffect(() => {
        const fetchProjectNetworks = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                    navigate('/login');
                    return;
                }
                const response = await axios.get('/api/applicant/messages/project-networks', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // console.log('response.data:', response.data);
                // console.log('response.data.projectNetworkList:', response.data.projectNetworkList);
                // console.log('response.data.allRooms:', response.data.allRooms);
                // const projectIds = new Set(response.data.projectNetworkList.map(p => p._id));
                // const filteredNew = response.data.allRooms.filter(prev => projectIds.has(prev._id));
                // const filteredPrevious = response.data.allRooms.filter(prev => !projectIds.has(prev._id));

                // setProjectNetworkList(filteredNew);
                // setPreviousNetworkList(filteredPrevious);
                setProjectNetworkList(response.data.projectNetworkList);
                setPreviousNetworkList(response.data.previousNetworkList);
            } catch (error) {
                // console.error('Error fetching project networks:', error.message);
            }
        };

        fetchProjectNetworks();
    }, [navigate]);


     useEffect(() => {
        const handleSortMessageBox = ({ friendId, createdAt }) => {
            setProjectNetworkList(prev => {
                const friendExists  = prev.some(friend => friend._id === friendId);
                if (!friendExists) return prev;

                return [...prev]
                    .map(friend =>
                        friend._id === friendId
                            ? { ...friend, lastMessageCreatedAt: createdAt }
                            : friend
                    )
                    .sort((a, b) => {
                        const dateA = new Date(a.lastMessageCreatedAt || 0);
                        const dateB = new Date(b.lastMessageCreatedAt || 0);
                        return dateB - dateA;
                    });
            });

        setPreviousNetworkList(prev => {
            const friendExists = prev.some(friend => friend._id === friendId);
            if (!friendExists) return prev;

            return [...prev]
                .map(friend =>
                    friend._id === friendId
                        ? { ...friend, lastMessageCreatedAt: createdAt }
                        : friend
                )
                .sort((a, b) => {
                    const dateA = new Date(a.lastMessageCreatedAt || 0);
                    const dateB = new Date(b.lastMessageCreatedAt || 0);
                    return dateB - dateA;
                });
        });

        };
        socket.on('lastMessageUpdate', handleSortMessageBox);
        return () => socket.off('lastMessageUpdate', handleSortMessageBox);
    }, []);


    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages, blockedStatusState]);

    const handleCloseMessageBox = () => {
        setActiveMessageBox(null);
    };

    // const fetchOlderMessages = useCallback(async (roomId) => {
    //     try {
    //         const response = await axios.post(
    //             '/api/applicant/messages/get-messages',
    //             { currentRoomId: roomId },
    //             { headers: { Authorization: `Bearer ${token}` } }
    //         );

    //         if (response.data.success) {
    //             setMessages(response.data.messages);
    //         }
    //     } catch (error) {
    //         // console.error('Error fetching old messages:', error);
    //     }
    // }, [token]);

    const handleChatClick = async (network) => {
        if (!userId) return;
        try {
            // const roomId = await startChat(userId, network._id);
            if (roomId) {
                setActiveChat(network); 
                setCurrentRoomId(roomId);
            }
                const blockedStatus = blockedUsers[network._id] || false
                setblockedStatusState(blockedStatus);
        } catch (error) {
            // console.error('Error handling chat click:', error);
        }
    };

    const handleCloseChat = () => {
        setActiveChat(null);
        setCurrentRoomId(null);
        localStorage.removeItem('chatBoxPosition');
    };

    // const sendMessage = async () => {

    //     if (!recentMessage.trim() || !currentRoomId || !userId || !activeChat?._id) {
    //         // console.error("Missing required fields:", { currentRoomId, userId, activeChat, recentMessage });
    //         return;
    //     }
    //     setRecentMessage('');

    //     const messageToSend = recentMessage.trim();
    //     try {
    //         // console.log("currentRoomId:fe3", currentRoomId, "userId:fe3", userId, "activeChat :fe3", activeChat._id, "message:fe3", recentMessage);

    //         await axios.post('/api/applicant/messages/send-message', {
    //             roomId: currentRoomId,
    //             senderId: userId,
    //             receiverId : activeChat._id,
    //             message: messageToSend
    //         }, {
    //             headers: { Authorization: `Bearer ${token}` }
    //         });

    //     } catch (error) {
    //         // console.error("Error sending message:", error.response?.data || error.message);
    //         setRecentMessage(recentMessage); // Restore on error
    //     }
    // };

    const handleBlock = async (networkId) => {
        if (blockedStatusState) {
            await onUnblockUser(networkId);
        } else {
            await onBlockUser(networkId);
        }
        setShowActiveChatOptions(false);
    };

    const onBlockUser = async (networkId) => {
        const result = dispatch(blockUser(networkId));
        if (result.success) {
            setNotification(result.message);
            setTimeout(() => setNotification(''), 3000);
        }
        setblockedStatusState(true);
        // console.log("Blocked Status State:bu ", blockedStatusState);

    };

    const onUnblockUser = async (networkId) => {
        const result = dispatch(unblockUser(networkId));
        if (result.success) {
            setNotification(result.message);
            setTimeout(() => setNotification(''), 3000);
        }
        setblockedStatusState(false);
        // console.log("Blocked Status State:ub ", blockedStatusState);
    }
    const handleCloseNotification = () => {
        setNotification('');
    };
    const handleProfileClick = (networkId) => {
        navigate(`/profile/${networkId}`, 
            // { state: {  status: status  } }
        );  
    };

    const handleChatClick1 = (network) => {
        handleChatClick(network);
        setActiveChat(network);
        setActiveMessageBox(network);
    };

    // const handleCloseChat1 = () => {
    //     handleCloseChat();
    //     setActiveChat(null);
    // };

    // const handleDeleteMessageForAll = async (messageId) => {
    //     try {
    //         await axios.post('/api/applicant/messages/delete-message-for-all', { messageId }, {
    //             headers: { Authorization: `Bearer ${token}` }
    //         });

    //         setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
    //     } catch (error) {
    //         // console.error('Error deleting message for all:', error);
    //     }
    // };

    // const handleDeleteMessageForMe = async (messageId) => {
    //     try {
    //         await axios.post('/api/applicant/messages/delete-message-for-me', { messageId }, {
    //             headers: { Authorization: `Bearer ${token}` }
    //         });

    //         setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
    //     } catch (error) {
    //         // console.error('Error deleting message for me:', error);
    //     }
    // };

    // const getTotalUnreadCount = () => {
    //     const projectUnread = projectNetworkList.reduce(
    //         (sum, friend) => sum + (friend.unreadCount || 0), 0
    //     );
    //     const previousUnread = previousNetworkList.reduce(
    //         (sum, friend) => sum + (friend.unreadCount || 0), 0
    //     );
    //     return projectUnread + previousUnread;
    // };
    
    const handleCopyMessage = (messageId) => {
        const messageToCopy = messages.find(msg => msg._id === messageId);
        if (messageToCopy) {
            navigator.clipboard.writeText(messageToCopy.message)
                .then(() => {
                    setNotification('Message copied to clipboard!');
                    setTimeout(() => setNotification(''), 3000);
                }
                )
                .catch((err) => {
                    // console.error('Could not copy text: ', err);
                });
        }
    };
    // const formatDate = (date) => {
    //     const d = new Date(date);
    //     const now = new Date();
    //     const isThisYear = d.getFullYear() === now.getFullYear();
    //     const day = d.getDate().toString().padStart(2, '0');
    //     const month = (d.getMonth() + 1).toString().padStart(2, '0');
    //     const year = d.getFullYear().toString().slice(-2);
    //     const hours = d.getHours().toString().padStart(2, '0');
    //     const minutes = d.getMinutes().toString().padStart(2, '0');
    //     return isThisYear ? `${hours}:${minutes} ${day}/${month}` : `${hours}:${minutes} ${day}/${month}/${year}`;
    // };

    const handleClickOutside = (event) => {
        if (!event.target.closest(`.${styles.messageOptionsButton}`) && !event.target.closest(`.${styles.messageOptionsMenu}`)) {
            setShowOptions(null);
        }
    };
    const handleClickOutside2 = (event) => {
            if (!event.target.closest(`.${styles.closeButton}`) && !event.target.closest(`.${styles.activeChatOptionsMenu}`)) {
                setShowActiveChatOptions(false);
            }   
        };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        document.addEventListener('click', handleClickOutside2);
        return () => {
            document.removeEventListener('click', handleClickOutside2);
        };
    }, []);

    // const handleDragStart = (e) => {
    //     const chatBox = chatBoxRef.current;
    //     const rect = chatBox.getBoundingClientRect();
    //     const offsetX = e.clientX - rect.left;
    //     const offsetY = e.clientY - rect.top;

    //     const handleDrag = (e) => {
    //         const newLeft = e.clientX - offsetX;
    //         const newTop = e.clientY - offsetY;
    //         setChatBoxPosition({ top: newTop, left: newLeft });
    //     };

    //     const handleDragEnd = () => {
    //         document.removeEventListener('mousemove', handleDrag);
    //         document.removeEventListener('mouseup', handleDragEnd);
    //         localStorage.setItem('chatBoxPosition', JSON.stringify(chatBoxPosition));
    //     };

    //     document.addEventListener('mousemove', handleDrag);
    //     document.addEventListener('mouseup', handleDragEnd);
    // };

    
    return (
        <>
            <NavHeader />
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
            {/* {getTotalUnreadCount() > 0 && (
                <div className="total-unread-badge">
                    {getTotalUnreadCount()}
                </div>
            )} */}
            <div className={styles.chatContainer}>
            <div className={styles.projectNetworksList}>
                <div className={styles.sectionHeader}>
                    <h3>Project Networks</h3>
                    <div className={styles.onlineIndicator}></div>
                </div>
                <ul>
                    {projectNetworkList.map((network) => (
                        <li key={network._id} onClick={() => handleChatClick1(network)} className={styles.networkItem}>
                            <div className={styles.profileContainer}>
                                <img title={network.name} src={network.profilePicture ? network.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile1} alt="Profile" className={styles.profilePicture} />
                                <div className={styles.statusDot}></div>
                            </div>
                            <div className={styles.networkInfo}>
                                <span className={styles.networkName}>{network.name}</span>
                                {/* {unreadCounts[network.roomId] > 0 && (
                                        <span className={styles.unreadBadge}>
                                            {unreadCounts[network.roomId]}
                                        </span>
                                )} */}
                                {network.unreadCount > 0 && (
                                    <span className={styles.unreadBadge}>
                                        {network.unreadCount}
                                    </span>
                                 )}
                                <span className={styles.lastSeen}>Active now</span>
                            </div>
                        </li>
                    ))}
                </ul>
                {previousNetworkList.length > 0 && (
                    <>
                        <div className={styles.sectionHeader}>
                            <h3>Previous Networks</h3>
                        </div>
                        <ul>
                            {previousNetworkList.map((network) => (
                                <li key={network._id} onClick={() => handleChatClick1(network)} className={styles.networkItem}>
                                    <div className={styles.profileContainer}>
                                        <img title={network.name} src={network.profilePicture ? network.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile1} alt="Profile" className={styles.profilePicture} />
                                    </div>
                                    <div className={styles.networkInfo}>
                                        <span className={styles.networkName}>{network.name}</span>
                                        {network.unreadCount > 0 && (
                                            <span className={styles.unreadBadge}>
                                                {network.unreadCount}
                                            </span>
                                        )}
                                        <span className={styles.lastSeen}>Last seen 2h ago</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </div>
            {activeMessageBox && (
                <MessageBox activeChat={activeMessageBox} userId={userId}
                status={status}
                onClose={handleCloseMessageBox}/>
            )}
        </div>

        </>
    );
};

export default MessagesPage;

